module.exports = __webpack_public_path__ + "static/img/2.b97c460.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/eng/2.png
// module id = CG4G
// module chunks = 0